import Vue from 'vue';
import { parseFormFieldsProperties, setValueInLocalStorage } from '../helpers/utils';
import { initialData } from './state';

export default {
  updateSettings(state, payload) {
    // payload: color, size, classic
    state.appSettings = Object.assign({}, state.appSettings, payload);
  },
  updateUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  setSideNavVisibility(state, payload) {
    Vue.set(state.sideNav, 'collapsed', payload);
  },
  updateNotificationsCount(state, data) {
    Vue.set(state.notificationSideBar, 'unseen', data);
  },
  incrementNotificationsCount(state) {
    Vue.set(state.notificationSideBar, 'unseen', state.notificationSideBar.unseen + 1);
  },
  decrementNotificationsCount(state) {
    Vue.set(state.notificationSideBar, 'unseen', state.notificationSideBar.unseen - 1);
  },
  updateSideNavItems(state, data) {
    (data || []).unshift({
      id: 0,
      name: 'الصفحة الرئيسية',
      childMenuItems: [],
      route: '/',
      properties: `{"icon":"mdi-home"}`,
    });
    if (data) {
      // eslint-disable-next-line no-param-reassign
      data = data.map(
        parentRoute => ({
          ...parentRoute,
          icon: JSON.parse(parentRoute.properties || '{}').icon || 'mdi-chevron-left',
          childMenuItems: parentRoute.childMenuItems.map(childRoute => ({
            ...childRoute,
            icon: JSON.parse(childRoute.properties || '{}').icon || 'mdi-chevron-left',
            childMenuItems: childRoute.childMenuItems.map(subChildRoute => ({
              ...subChildRoute,
              icon: JSON.parse(subChildRoute.properties || '{}').icon || 'mdi-chevron-left',
            })),
          })),
        }),
        []
      );
      Vue.set(state.sideNav, 'data', data);
      setValueInLocalStorage('sidenav', data);
    }
  },
  resetActiveNavItem(state) {
    Vue.set(state.sideNav, 'activeItem', initialData().sideNav.activeItem);
  },
  updateActiveNavItem(state, payload) {
    if (payload.id && state.sideNav.activeItem.id !== payload.id)
      Vue.set(state.sideNav, 'activeItem', {
        ...state.sideNav.activeItem,
        ...payload,
      });
  },
  addDataGrid(state, payload) {
    Vue.set(state.flatDataGrids, payload.id, payload);
    setValueInLocalStorage('grids', state.flatDataGrids);
  },
  updateDataGrid(state, payload) {
    state.dataGrid = payload;
  },
  updateDataGridLabel(state, payload) {
    Vue.set(state.dataGrid, 'label', payload);
  },
  updateDataGridEndPointUrl(state, payload) {
    Vue.set(state.dataGrid, 'endPointUrl', payload);
  },
  updateDataGridProperties(state, payload) {
    Vue.set(state.dataGrid, 'properties', payload);
  },
  updateDataGridFilters(state, payload) {
    state.dataGrid.filters = payload.map(filter => ({
      ...filter,
      validations: (JSON.parse(filter.properties) || {}).validations,
    }));
  },
  updateDataGridActions(state, payload) {
    state.dataGrid.actions = payload
      .sort((a, b) => a.order - b.order)
      .map(action => ({
        ...action,
        properties: JSON.parse(action.properties) || {},
        icon: (JSON.parse(action.properties) || {}).icon,
        tooltip: (JSON.parse(action.properties) || {}).tooltip,
        buttonType: 'primary',
      }));
    if (payload.length) {
      state.dataGrid.columns.unshift({
        type: 'selection',
        width: '70px',
      });
    }
  },
  updateDataGridColumns(state, payload) {
    state.dataGrid.columns = payload
      .sort((a, b) => a.order - b.order)
      .map(column => ({
        text: column.header,
        value: column.actionType ? 'action' : column.name,
        actionValue: column.actionType ? column.name : null,
        sortable: column.isSortAllowed,
        slot: column.actionType,
        httpMethod: column.httpMethod,
        actionName: column.actionName,
        isActionDisabled: column.isActionDisabled,
        className: column.actionType ? 'action-column' : '',
        width: column.actionType ? '100px' : '',
        align: 'center',
        actions: column.actions,
        dataType: column.dataType,
        hidden: column.isHidden,
      }));
    if (state.dataGrid.actions.length) {
      state.dataGrid.columns.unshift({
        type: 'selection',
        width: '70px',
      });
    }
  },
  updateDataGridSorting(state, payload) {
    state.dataGrid.searchQuery.sorting = {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
    };
  },
  updateDataGridPageSize(state, payload) {
    // state.dataGrid.items = [];
    // state.dataGrid.total = 0;
    state.dataGrid.searchQuery.paging = {
      ...state.dataGrid.searchQuery.paging,
      pageSize: payload,
      pageIndex: 0,
    };
  },
  updateDataGridPageIndex(state, payload) {
    // state.dataGrid.items = [];
    // state.dataGrid.total = 0;
    state.dataGrid.searchQuery.paging = {
      ...state.dataGrid.searchQuery.paging,
      pageIndex: payload,
    };
  },
  updateDataGridSearchQuery(state, payload) {
    // state.dataGrid.items = [];
    // state.dataGrid.total = 0;
    state.dataGrid.searchQuery.paging = {
      ...state.dataGrid.searchQuery.paging,
      pageIndex: 0,
    };
    state.dataGrid.searchQuery.filters = payload;
  },
  updateDataGridItems(state, payload) {
    state.dataGrid.items = payload.items;
    state.dataGrid.total = payload.total;
    state.dataGrid.searchQuery.paging = {
      ...state.dataGrid.searchQuery.paging,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    };
  },
  updateAppLoader(state, payload) {
    state.appLoader = Object.assign({}, state.appLoader, payload);
  },
  updateOverlayLoader(state, payload) {
    state.overlayLoader = Object.assign({}, state.overlayLoader, payload);
  },
  clearBreadcrumbsData(state) {
    // {
    //   params: {},
    //   data: [],
    // }
    state.breadcrumbs.data = [];
  },
  updateBreadcrumbs(state, payload) {
    // {
    //   params: {},
    //   data: [],
    // }
    state.breadcrumbs.params = {
      ...state.breadcrumbs.params,
      ...payload.params,
    };
    state.breadcrumbs.data = state.breadcrumbs.data.concat(payload.data);
  },
  updateDynamicForms(state, dynamicForms) {
    state.dynamicForms = dynamicForms.map(form => ({
      ...form,
      fields: parseFormFieldsProperties(form.fields),
    }));
  },
  updateDynamicForm(state, dynamicForm) {
    const hasSelectedForm = state.dynamicForms.find(f => f.id == dynamicForm.id);
    const newForm = {
      ...dynamicForm,
      fields: parseFormFieldsProperties(dynamicForm.fields),
    };
    state.dynamicForms = hasSelectedForm
      ? state.dynamicForms.map((form) => {
        return form.id == dynamicForm.id ? newForm : form;
      })
      : state.dynamicForms.length
        ? state.dynamicForms.concat(newForm)
        : [newForm];
  },
  updatePickLists(state, pickLists) {
    state.pickLists = pickLists;
  },
  updateDynamicGrids(state, dynamicGrids) {
    state.dynamicGrids = dynamicGrids;
  },
  updateDynamicGrid(state, dynamicGrid) {
    state.dynamicGrids = state.dynamicGrids.map((form) => {
      return form.id == dynamicGrid.id ? dynamicGrid : form;
    });
  },
};
